/* パララックス */

let parallax = () => {
  gsap.utils.toArray('.js-parallax').forEach((el) => {
    const y = el.getAttribute('data-y') || -50;
    const start = el.getAttribute('data-start') || 'start bottom';

    gsap.to(el, {
      y: y,
      scrollTrigger: {
        trigger: el,
        start: start,
        end: 'bottom top',
        scrub: 1,
        //markers: true
      },
    });
  });

  gsap.utils.toArray('.js-parallax-bg').forEach((el) => {
    const y = el.getAttribute('data-y') || '-50px';
    const x = el.getAttribute('data-x') || '-50px'; // スマホ用オフセット値
    const start = el.getAttribute('data-start') || 'start bottom';
    const isSP = window.matchMedia('(max-width: 768px)').matches;

    // PCとSPで動きを切り替え
    if (isSP) {
      // スマホ時（X軸方向：右→左）
      gsap.to(el, {
        backgroundPosition: x + ' 0px', // X軸のみ動かす
        force3D: true,
        rotation: 0.01,
        z: 0.01,
        autoRound: false,
        scrollTrigger: {
          trigger: el,
          start: start,
          end: 'bottom top',
          scrub: 1,
          // markers: true,
        },
      });
    } else {
      // PC時（Y軸方向：下→上）
      gsap.to(el, {
        backgroundPosition: '0px ' + y, // Y軸のみ動かす
        force3D: true,
        rotation: 0.01,
        z: 0.01,
        autoRound: false,
        scrollTrigger: {
          trigger: el,
          start: start,
          end: 'bottom top',
          scrub: 1,
          // markers: true,
        },
      });
    }
  });
};

/**
 * 初期化
 */
let init = () => {
  parallax();
};

export default { init, parallax };
